import { createEntityCollectionStore } from '@core/ngrx-legacy';
import { JobBoard } from '@recruitee/job-boards-types';

const { actions, namespace, selectors, reducer } =
  createEntityCollectionStore<JobBoard>()('JobBoard');

export {
  actions as JobBoardActions,
  namespace as JobBoardNamespace,
  reducer as JobBoardReducer,
  selectors as JobBoardSelectors,
};
